// extracted by mini-css-extract-plugin
module.exports = {"button":"StripeApplePayButton_button__DApR4","logo":"StripeApplePayButton_logo__Td24W"};